module.exports = __webpack_public_path__ + "static/media/campaint_main_image.c31d453f.svg";